import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { debounce, get } from "lodash";
import Layout from "../Common/Layout";
import { Grid } from "semantic-ui-react";
import build from "redux-object";
import Loader from "../Common/Loader";
import ResourceList from "../Common/ResourceList";
import { deleteUser, fetchUsers } from "../../actions/user.actions";
import { UserList } from "./UserList";

export class UsersListPage extends PureComponent {
  deleteUser = id => {
    this.props.dispatch(deleteUser(id));
  };

  fetchList = () => {
    this.props.dispatch(fetchUsers());
  };

  fetchListDebounced = debounce(this.fetchList, 500);

  render() {
    const { currentUser } = this.props;

    if (currentUser && currentUser.admin !== true) {
      return (
        <Layout.Page>
          <Layout.Header title="Admin" />
          <Layout.Content>
            <p>You don't have the expected credentials to see this page.</p>
          </Layout.Content>
        </Layout.Page>
      );
    }
    return (
      <Layout.Page>
        <Layout.Header title="Admin page" />
        <Layout.Content>
          <Grid padded>
            <Grid.Row verticalAlign="middle">
              <ResourceList
                resourceType={"users"}
                fetch={this.fetchListDebounced}
                loader={<Loader key="__Users_Loader" message="Loading users..." />}
              >
                {list => <UserList users={list || []} currentUser={currentUser} onDelete={this.deleteUser} />}
              </ResourceList>
            </Grid.Row>
          </Grid>
        </Layout.Content>
      </Layout.Page>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: get(state, "common.currentUser"),
  tenants: build(state.common, "tenants", null, { ignoreLinks: true }),
  tenantSlug: get(state, "common.currentTenant.slug")
});

export default connect(mapStateToProps)(UsersListPage);
